import { createTheme } from '@material-ui/core/styles';



const theme = createTheme({
 typography: {
   fontFamily: ['Arial', 'Helvetica'].join(','),
     fontSize: ['0.75em'],
     color: ['red']
  }
})

export default theme;